import { createSlice } from '@reduxjs/toolkit';

export interface CreditReportState {
  creditReportDetails: {};
}

const initialState: CreditReportState = {
  creditReportDetails: {},
};

export const creditReportSlice = createSlice({
  name: 'creditReport',
  initialState,
  reducers: {
    fetchCreditReport: (state, action) => {},
    fetchCreditReportByPan: (state, action) => {},
    fetchCreditReportByMaskedNumber: (state, action) => {},
    fetchBureauData: (state, action) => {},
    fetchUserDetails: (state, action) => {},
    updateUserDetails: (state, action) => {},
    saveCreditReportData: (state, action) => {
      state.creditReportDetails = { ...action.payload };
    },
    resetCreditReportData: (state) => {
      state.creditReportDetails = {};
    },
    revokeConsent: (state, action) => {},
    captureLead: (state, action) => {},
  },
});

export const {
  saveCreditReportData,
  fetchCreditReport,
  fetchCreditReportByPan,
  fetchCreditReportByMaskedNumber,
  revokeConsent,
  captureLead,
  fetchUserDetails,
  updateUserDetails,
  resetCreditReportData,
  fetchBureauData,
} = creditReportSlice.actions;
export default creditReportSlice.reducer;
